import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tenant-bids.reducer';

export const TenantBidsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tenantBidsEntity = useAppSelector(state => state.tenantBids.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tenantBidsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.tenantBids.detail.title">TenantBids</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.tenantBids.id">Id</Translate>
            </span>
          </dt>
          <dd>{tenantBidsEntity.id}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="tinyMedicRestApp.tenantBids.status">Status</Translate>
            </span>
          </dt>
          <dd>{tenantBidsEntity.status}</dd>
          <dt>
            <span id="createdById">
              <Translate contentKey="tinyMedicRestApp.tenantBids.createdById">Created By Id</Translate>
            </span>
          </dt>
          <dd>{tenantBidsEntity.createdById}</dd>
          <dt>
            <span id="createdByType">
              <Translate contentKey="tinyMedicRestApp.tenantBids.createdByType">Created By Type</Translate>
            </span>
          </dt>
          <dd>{tenantBidsEntity.createdByType}</dd>
          <dt>
            <span id="billFor">
              <Translate contentKey="tinyMedicRestApp.tenantBids.billFor">Bill For</Translate>
            </span>
          </dt>
          <dd>{tenantBidsEntity.billFor}</dd>
          <dt>
            <span id="patientType">
              <Translate contentKey="tinyMedicRestApp.tenantBids.patientType">Patient Type</Translate>
            </span>
          </dt>
          <dd>{tenantBidsEntity.patientType}</dd>
          <dt>
            <span id="bidSubmittedDate">
              <Translate contentKey="tinyMedicRestApp.tenantBids.bidSubmittedDate">Bid Submitted Date</Translate>
            </span>
          </dt>
          <dd>{tenantBidsEntity.bidSubmittedDate}</dd>
          <dt>
            <span id="bidAcceptedDate">
              <Translate contentKey="tinyMedicRestApp.tenantBids.bidAcceptedDate">Bid Accepted Date</Translate>
            </span>
          </dt>
          <dd>{tenantBidsEntity.bidAcceptedDate}</dd>
          <dt>
            <span id="totalCost">
              <Translate contentKey="tinyMedicRestApp.tenantBids.totalCost">Total Cost</Translate>
            </span>
          </dt>
          <dd>{tenantBidsEntity.totalCost}</dd>
          <dt>
            <span id="discount">
              <Translate contentKey="tinyMedicRestApp.tenantBids.discount">Discount</Translate>
            </span>
          </dt>
          <dd>{tenantBidsEntity.discount}</dd>
          <dt>
            <span id="cgst">
              <Translate contentKey="tinyMedicRestApp.tenantBids.cgst">Cgst</Translate>
            </span>
          </dt>
          <dd>{tenantBidsEntity.cgst}</dd>
          <dt>
            <span id="sgst">
              <Translate contentKey="tinyMedicRestApp.tenantBids.sgst">Sgst</Translate>
            </span>
          </dt>
          <dd>{tenantBidsEntity.sgst}</dd>
          <dt>
            <span id="roundOffVal">
              <Translate contentKey="tinyMedicRestApp.tenantBids.roundOffVal">Round Off Val</Translate>
            </span>
          </dt>
          <dd>{tenantBidsEntity.roundOffVal}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.tenantBids.active">Active</Translate>
            </span>
          </dt>
          <dd>{tenantBidsEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.tenantBids.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{tenantBidsEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tenantBids.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{tenantBidsEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.tenantBids.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{tenantBidsEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tenantBids.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{tenantBidsEntity.timestampEntry}</dd>
          <dt>
            <span id="homeDeliveryAvailable">
              <Translate contentKey="tinyMedicRestApp.tenantBids.homeDeliveryAvailable">Home Delivery Available</Translate>
            </span>
          </dt>
          <dd>{tenantBidsEntity.homeDeliveryAvailable ? 'true' : 'false'}</dd>
          <dt>
            <span id="deliveryTime">
              <Translate contentKey="tinyMedicRestApp.tenantBids.deliveryTime">Delivery Time</Translate>
            </span>
          </dt>
          <dd>{tenantBidsEntity.deliveryTime}</dd>
          <dt>
            <span id="deliveryCost">
              <Translate contentKey="tinyMedicRestApp.tenantBids.deliveryCost">Delivery Cost</Translate>
            </span>
          </dt>
          <dd>{tenantBidsEntity.deliveryCost}</dd>
          <dt>
            <span id="grossAmount">
              <Translate contentKey="tinyMedicRestApp.tenantBids.grossAmount">Gross Amount</Translate>
            </span>
          </dt>
          <dd>{tenantBidsEntity.grossAmount}</dd>
          <dt>
            <span id="bidNumber">
              <Translate contentKey="tinyMedicRestApp.tenantBids.bidNumber">Bid Number</Translate>
            </span>
          </dt>
          <dd>{tenantBidsEntity.bidNumber}</dd>
          <dt>
            <span id="bidDate">
              <Translate contentKey="tinyMedicRestApp.tenantBids.bidDate">Bid Date</Translate>
            </span>
          </dt>
          <dd>{tenantBidsEntity.bidDate}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tenantBids.tinymedicPatientOrder">Tinymedic Patient Order</Translate>
          </dt>
          <dd>{tenantBidsEntity.tinymedicPatientOrder ? tenantBidsEntity.tinymedicPatientOrder.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tenantBids.tenant">Tenant</Translate>
          </dt>
          <dd>{tenantBidsEntity.tenant ? tenantBidsEntity.tenant.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tenant-bids" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tenant-bids/${tenantBidsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TenantBidsDetail;
